// The invitation types staff can choose from, mirroring the API's enum. Staff
// pick a named thing ("GM playtester"), not a set of roles — the API maps the
// type to the d3-auth roles that grant it. Keep the slugs in sync with
// internal/staff/apioperations/invitations.go.
// D3 Community is first, so it is the default selection.
export const INVITATION_TYPES = [
    {
        slug: 'd3-community',
        label: 'D3 Community',
        hint: 'The community site only — no VTT early access.',
    },
    {
        slug: 'vtt-playtest',
        label: 'VTT Playtest',
        hint: 'Early access to the VTT playtest, plus the community site.',
    },
];

/**
 * @param {string} slug
 * @returns {string} the type's label, or the slug when it is not one we know.
 */
export function invitationTypeLabel(slug) {
    return INVITATION_TYPES.find((t) => t.slug === slug)?.label ?? slug;
}
